import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import type { Dropdown } from 'ember-basic-dropdown/components/basic-dropdown';
import type { TOC } from '@ember/component/template-only';
export interface BvPopoverFooterSignature {
    Args: {
        popover?: Dropdown;
    };
    Blocks: {
        default: [popover?: Dropdown];
    };
    Element: HTMLElement;
}
const BvPopoverFooterComponent: TOC<BvPopoverFooterSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  <footer class='bv-popover__footer' ...attributes>
    {{yield @popover}}
  </footer>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default BvPopoverFooterComponent;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        'BvPopover::Footer': typeof BvPopoverFooterComponent;
        'bv-popover/footer': typeof BvPopoverFooterComponent;
    }
}
